import { render, staticRenderFns } from "./StoryBorderColorSettings.vue?vue&type=template&id=34a091a1&scoped=true&"
import script from "./StoryBorderColorSettings.vue?vue&type=script&lang=js&"
export * from "./StoryBorderColorSettings.vue?vue&type=script&lang=js&"
import style0 from "./StoryBorderColorSettings.vue?vue&type=style&index=0&id=34a091a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a091a1",
  null
  
)

export default component.exports